import axios from 'axios'
import i18n from '@/plugins/i18n'

// Модель для работы с мероприятиями
export default {
  // Получение списка
  getList (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/eventReport/getEventReports?${filter}`)
  },
  // Получение данных для формы
  getEventReportFormData () {
    return axios.get(`${i18n.locale}/api/eventReport/getEventReportFormData`)
  },
  // Создание
  createEventReport (data) {
    return axios.post(`${i18n.locale}/api/eventReport/createEventReport`, data)
  },
  // Получение списка составителей
  getOoptObservers (id) {
    return axios.get(`${i18n.locale}/api/eventReport/getOoptObservers/${id}`)
  },
  // Редактирование
  editEventReport (id, statusId, data) {
    return axios.post(`${i18n.locale}/api/eventReport/editEventReport/${id}/${statusId}`, data)
  },
  // Получение данных
  getEventReportData (id) {
    return axios.get(`${i18n.locale}/api/eventReport/getEventReportData/${id}`)
  },
  // Список действий
  getActions (statusId) {
    return axios.get(`${i18n.locale}/api/eventReport/actions/${statusId}`)
  },
  // Изменение статуса
  changeStatus (id, data) {
    return axios.post(`${i18n.locale}/api/eventReport/changeStatus/${id}`, data)
  },
  // печать в excel
  excelPrint (id) {
    return axios.get(`${i18n.locale}/api/eventReport/excel-print/${id}`, { responseType: 'arraybuffer' })
  }
}
